define([], function () {
    'use strict';

    return function isComponentVisible({isCompHiddenByRenderPlugin, renderFlags}) {
        const isCompHidden = renderFlags.componentViewMode !== 'preview' && isCompHiddenByRenderPlugin;
        return !isCompHidden;
    };
});
